import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";

import {
  ConfirmModalProps,
  ConfirmModalTextProps,
  ModalTitles,
  ModalMessages,
  RegisterResponses,
} from "src/library/types/types";

export const showErrorModal = (openConfirmModal: Function, error?: Error) => {
  const errorMessage = error?.message || "";
  let userMessage = "";
  switch (errorMessage) {
    case RegisterResponses.PrivacyError:
      userMessage = ModalMessages.PrivacyError;
      break;
    case RegisterResponses.FormError:
      userMessage = ModalMessages.FormError;
      break;
    case RegisterResponses.VerifyCaptchaError:
    case RegisterResponses.CaptchaError:
      userMessage = ModalMessages.CaptchaError;
      break;
    case RegisterResponses.RegisterError:
    case RegisterResponses.NotFound:
      userMessage = ModalMessages.RegisterError;
      break;
    default:
      userMessage = ModalMessages.DefaultError;
      break;
  }
  const captchaErrorModal: ConfirmModalTextProps = {
    title: ModalTitles.DefaultError,
    message: userMessage,
    confirmButton: "OK",
  };
  openConfirmModal(captchaErrorModal);
};

export const showSuccessModal = (openConfirmModal: Function, message?: string) => {
  const captchaSuccessModal: ConfirmModalTextProps = {
    title: ModalTitles.Success,
    message: message || "Your registration was successful",
    confirmButton: "OK",
  };
  openConfirmModal(captchaSuccessModal);
};

export default function ConfirmModal(props: ConfirmModalProps) {
  const { confirmModal, closeConfirmModal, confirmModalText } = props;
  return (
    <Dialog
      open={confirmModal}
      onClose={closeConfirmModal}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
    >
      <Box id="confirm-dialog-title" sx={{ pt: 4, px: 4, pb: 2 }}>
        <Typography variant="h4" color="text">
          {confirmModalText?.title || "Heads Up!"}
        </Typography>
      </Box>
      <DialogContent>
        <Typography color="text.secondary" variant="subtitle1">
          {confirmModalText?.message ||
            "Something has gone wrong with this popup modal. Please close this modal and try again!"}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ pb: 3, pr: 3 }}>
        {confirmModalText?.cancelButton && (
          <Button
            onClick={closeConfirmModal}
            color="secondary"
            sx={{ mr: 2, borderRadius: 0, fontWeight: "fontWeightBold" }}
            component="button"
          >
            {confirmModalText.cancelButton || "Cancel"}
          </Button>
        )}
        <Button
          onClick={closeConfirmModal}
          autoFocus
          variant="contained"
          color="secondary"
          sx={{
            borderRadius: 0,
            borderWidth: "2px",
            px: 4,
            "&:hover": { color: "common.white" },
          }}
        >
          <Typography fontWeight="fontWeightBold">
            {confirmModalText?.confirmButton || "OK"}
          </Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
}
